
import { createContext } from "react";

import { HubConnection } from "@microsoft/signalr";

export interface ISignalROnConnect {
    (connection: HubConnection): void | Promise<void>;
}

export interface ISignalROnReconnect {
    (connection: HubConnection, connectionId?: string): void | Promise<void>;
}

export interface ISignalROnReconnecting {
    (connection: HubConnection, error?: Error): void | Promise<void>;
}

export interface ISignalROnClose {
    (connection: HubConnection, error?: Error): void | Promise<void>;
}


export interface ISignalROnMessage<TData = any> {
    (connection: HubConnection, data: TData): void | Promise<void>;
}


export interface ISignalROnJoin {
    (connection: HubConnection): void | Promise<void>;
}

export interface ISignalROnLeave {
    (connection: HubConnection): void | Promise<void>;
}

export interface ISignalRUnsubscribe {
    (): void;
}

export interface ISignalRListeners {
    onConnect: ISignalROnConnect[];
    onJoin: ISignalROnJoin[];
    onLeave: ISignalROnLeave[]; 
    onMessage: ISignalROnMessage[];
    onReconnect: ISignalROnReconnect[];
    onClose: ISignalROnClose[];
    onReconnecting: ISignalROnReconnecting[];
}

export interface ISignalRContext {
    addOnConnectListener: (channel: string, listener: ISignalROnConnect) => ISignalRUnsubscribe;
    addOnJoinListener: (channel: string, listener: ISignalROnJoin) => ISignalRUnsubscribe;
    addOnLeaveListener: (channel: string, listener: ISignalROnLeave) => ISignalRUnsubscribe;
    addOnMessageListener: <TData = any>(channel: string, listener: ISignalROnMessage<TData>) => ISignalRUnsubscribe;
    addOnReconnectListener: (channel: string, listener: ISignalROnReconnect) => ISignalRUnsubscribe;
    addOnCloseListener: (channel: string, listener: ISignalROnClose) => ISignalRUnsubscribe;
    addOnReconnectingListener: (channel: string, listener: ISignalROnReconnecting) => ISignalRUnsubscribe;
}

export const SignalRContext = createContext<ISignalRContext>({
    addOnConnectListener: (_channel, _listener) => {
        return () => {};
    },
    addOnJoinListener: (_channel, _listener) => {
        return () => {};
    },
    addOnLeaveListener: (_channel, _listener) => {
        return () => {};
    },
    addOnMessageListener: (_channel, _listener) => {
        return () => {};
    },
    addOnReconnectListener: (_channel, _listener) => {
        return () => {};
    },
    addOnCloseListener: (_channel, _listener) => {
        return () => {};
    },
    addOnReconnectingListener: (_channel, _listener) => {
        return () => {};
    }
});

export default SignalRContext;